import { useContext } from 'react';
import { IdentityContext, IIdentityContext } from './identity-context';

export function useIdentity(allowAnonymous?: boolean): IIdentityContext & {
	/** @obsolete Do not use this, provided for backwards compatability only. This value will never change in practice, use getAccessToken() instead */
	accessToken?: string;
} {
	const context = useContext(IdentityContext);
	if (!context) {
		if (allowAnonymous === true)
			return {
				authorized: false,
				getAccessToken: () => undefined,
				ensureAuthenticated: () => Promise.resolve(false),
				recordActivity: () => {},
				userIsActive: () => false
			};
		throw new Error('Identity Context is unavailable');
	}

	return { ...context, accessToken: context.getAccessToken() };
}
